<template>
  <div class="modular c-custom_modular">
    <el-input
      class="modular_search"
      v-model="search_content"
      :placeholder="$t('view_left_sidebar_module_add_module_236')"
      prefix-icon="el-icon-search"
      @input="search"
    ></el-input>
    <my_collapse v-model="activeName" @change-item="change_collapse_item">
      <my_collapse_item
        :title="$t('view_left_sidebar_module_add_module_237')"
        name="commonly"
        v-show="commonlyList.length > 0"
        ref="commonlyRef"
      >
        <div
          class="add_module_item"
          v-for="(item, index) in commonlyList"
          :key="index"
          data-make="add_module"
          :data-name="item.name"
          v-if="item.isShow"
        >
          <div class="add_module_box" @click="click_add_module(item)">
            <div
              :class="['add_module_icon',item.usePrivateIcon?'module-icon-private':'module-icon-common',item.name]"
              :style="{ backgroundPosition: item.icon_position,...getBackgroundImageStyle(item)}"
            ></div>
            <div class="add_module_text">{{ $t(item.title) }}</div>
          </div>
        </div>
      </my_collapse_item>

      <my_collapse_item
        :title="$t('view_left_sidebar_module_add_module_238')"
        name="basics"
        v-show="basicsList.length > 0"
        ref="basicsRef"
      >
        <div
          class="add_module_item"
          v-for="(item, index) in basicsList"
          :key="index"
          data-make="add_module"
          :data-name="item.name"
          v-if="item.isShow"
        >
          <div class="add_module_box" @click="click_add_module(item)">
            <div
              class="add_module_icon_new"
              v-if="item.name === 'basic_crumbs'"
            >
              <i class="iconfont icon-tubiao- basic_crumbs"></i>
            </div>
            <div
              v-else
              :class="['add_module_icon',item.usePrivateIcon?'module-icon-private':'module-icon-common',item.name]"
              :style="{ backgroundPosition: item.icon_position,...getBackgroundImageStyle(item)}"
            ></div>
            <div class="add_module_text">{{ $t(item.title) }}</div>
          </div>
        </div>
      </my_collapse_item>

      <my_collapse_item
        :title="$t('view_left_sidebar_module_add_module_239')"
        name="layout"
        v-show="layoutList.length > 0"
        ref="layoutRef"
      >
        <template v-if="canAddLayoutModule">
          <div
            :class="item.name==='layout_row'?'add_module_layout':'add_module_item'"
            v-for="(item, index) in layoutList"
            :key="index"
            data-make="add_module"
            :data-name="item.name"
            v-if="item.isShow"
          >
            <div class="add_module_box" @click="click_add_module(item)">
              <div
                :class="['add_module_icon',item.usePrivateIcon?'module-icon-private':'module-icon-common',item.name]"
                :style="{ backgroundPosition: item.icon_position,...getBackgroundImageStyle(item)}"
              ></div>
              <div class="add_module_text">{{ $t(item.title) }}</div>
            </div>
          </div>
        </template>
        <div v-else class="tip-not-support">{{$t('view_left_sidebar_module_add_module_240')}}</div>
      </my_collapse_item>
      <my_collapse_item
        :title="$t('view_left_sidebar_module_add_module_241')"
        name="interaction"
        v-show="interactionList.length > 0"
        ref="interactionRef"
      >
        <div
          class="add_module_item"
          v-for="(item, index) in interactionList"
          :key="index"
          data-make="add_module"
          :data-name="item.name"
          v-if="item.isShow"
        >
          <div class="add_module_box" @click="click_add_module(item)">
            <div
              :class="['add_module_icon',item.usePrivateIcon?'module-icon-private':'module-icon-common',item.name]"
              :style="{ backgroundPosition: item.icon_position,...getBackgroundImageStyle(item)}"
            ></div>
            <div class="add_module_text">{{ $t(item.title) }}</div>
          </div>
        </div>
      </my_collapse_item>
      <my_collapse_item
        :title="$t('view_left_sidebar_module_add_module_242')"
        name="senior"
        v-show="seniorList.length > 0"

        ref="seniorRef"
      >
        <template v-for="(item, index) in seniorList">
          <!-- v-for 和 v-if 不能一起 加了一个 template -->
          <div
            class="add_module_item"

            :key="index"
            data-make="add_module"
            :data-name="item.name"
            v-if="item.isShow"
          >
            <div class="add_module_box" @click="click_add_module(item)">
              <div
                :class="['add_module_icon',item.usePrivateIcon?'module-icon-private':'module-icon-common',item.name]"
                :style="{ backgroundPosition: item.icon_position,...getBackgroundImageStyle(item)}"
              ></div>
              <div class="add_module_text">{{ $t(item.title) }}</div>
            </div>
          </div>
        </template>

      </my_collapse_item>
    </my_collapse>
  </div>
</template>

<script>
import i18n from '../../../language/index'

// import Module from '@/base/one_module';
// import Row from '@/base/one_row';
import {mapState} from "vuex";
import {mydebounce} from "@/base/base";

export default {
  name: "left_sidebar_add_module",
  data() {
    return {
      activeName: ["commonly", "basics", "interaction", "senior", "layout"],
      search_content: "",
    };
  },
  computed: {
    ...mapState("left_sidebar", ["searchContent"]),
    commonlyList() {
      return this.filteredPendantList.filter(
        (item) => item.type === "commonly"
      );
    },
    basicsList() {
      return this.filteredPendantList.filter(
        (item) => item.type === "basics"
      );
    },
    interactionList() {
      return this.filteredPendantList.filter(
        (item) => item.type === "interaction"
      );
    },
    seniorList() {
      return this.filteredPendantList.filter(
        (item) => item.type === "senior"
      );
    },
    layoutList() {
      return this.filteredPendantList.filter(
        (item) => item.type === "layout"
      );
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    filteredPendantList() {
      return this.$store.state.left_sidebar.PendantList.filter((item) => {
        if (item.isOnlyDomestic === true) {
          return this.isDomesticSite
        } else {
          return true
        }
      })
    },
    isDomesticSite() {
      return this.$store.state.app.language == 'zh-cn' && this.$store.state.app.road_type != 1
    },
    canAddLayoutModule() {
      // #u1000002
      let col_id = this.$store.state.app.addModule_col

      return $(`#u${col_id}`).parents('.basic-row-tab').length === 0
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    }
  },
  watch: {
    searchContent(v) {
      this.search_content = v;
    },
  },
  methods: {
    init() {
      this.search_content = this.searchContent;
      this.search(this.search_content);
    },
    click_add_module(item) {
      if(this.isFullPage && this.$store.state.app.view_pattern === "pc") { //新增全屏通栏
          const page = [...document.querySelectorAll('#full-page-nav li')];
          if(page.length > 14) {
            this.$message.warning(i18n.t('view_left_sidebar_module_add_module_243'))
            return
          }
      }
      const col_id = this.$store.state.app.addModule_col;

      if (item.name === 'layout_row') {
        // 添加通栏，可能是普通页面，也可能是全屏滚动页面
        let index = this.$store.state.myRender.body.length
        this.templet.add_row(index, this.$store.state.myRender.body[0])
        if (this.isFullPage) {
          setTimeout(() => {
            window.fullPage && fullPage.resetData()
            window.fullPage && fullPage.resetHeight()
            window.fullPage && fullPage.goLastPage()
          }, 100)
        }
        return;
      }

      if (this.isFullPage && !col_id) {
        // 如果是全屏滚动，点击模块，添加一屏
        const row_index = this.$store.state.myRender.body.length;
        //新增行和列，并返回列id
        const row_col = this.templet.add_row(row_index, {rowType: "body"});
        const c_id = row_col.col.widgets_id;
        const r_id = row_col.row.widgets_id;
        this.templet.add_module(c_id, 0, item.name);
        setTimeout(() => {
          window.fullPage && fullPage.resetData()
          window.fullPage && fullPage.resetHeight()
          window.fullPage && fullPage.goLastPage()
        }, 100)

        return
      }


      //有指定的col
      if (col_id != null) {
        //始终加入到最后一个
        this.templet.add_module(col_id, 9999, item.name);
      } else {
        const row_index = this.$store.state.myRender.body.length;
        //新增行和列，并返回列id
        const row_col = this.templet.add_row(row_index, {rowType: "body"});
        const c_id = row_col.col.widgets_id;
        const r_id = row_col.row.widgets_id;
        this.templet.add_module(c_id, 0, item.name);
        this.$nextTick(() => {
          this.templet.row_scroll(r_id);
        });
      }
    },
    change_collapse_item(item) {
      if (item.status) {
        // 打开面板后重新绑定值
        this.$nextTick(() => {
          this.templet.left_sidebar_draggable();
        });
      }
    },
    search(v) {
      const fn = (v) => {
        const clearFn = (arr) => {
          for (let i = 0; i < arr.length; i++) {
            arr.splice(i, 1);
            i--;
          }
        };
        const n = ["commonly", "basics", "interaction", "senior", "layout"];
        v = v.replace(/(^\s*)|(\s*$)/g, "");
        n.map((k) => clearFn(this[`${k}List`]));
        this.$store.state.left_sidebar.PendantList.map((item) => {
          const {title, type} = item;
          if (title.indexOf(v) !== -1 || v === "") {
            if (this.isDomesticSite || (item.isOnlyDomestic !== true)) {
              this[`${type}List`].push(item);
            }
          }
        });
        this.activeName = [];
        n.map((k) => {
          if (this[`${k}List`].length > 0) this.activeName.push(k);
        });
        this.$store.commit("left_sidebar/set_search_content", v);
        n.map((k) => {
          this.$nextTick(() => {
            const $el = this.$refs[`${k}Ref`].$el.children[1];
            if ($el) $el.style.height = $el.children[0].offsetHeight + "px";
          });
        });
        this.$nextTick(() => {
          this.templet.left_sidebar_draggable();
        });
      };
      mydebounce.call(this, fn, 300)(v);
    },
    getBackgroundImageStyle(item) {
      if (item.usePrivateIcon) {
        return {
          backgroundImage: `url("/static/image/widget_icon/${item.name}.png")`,
        }
      } else {
        return {}
      }
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.modular {
  padding: 16px 13px;

  .modular_search {
    /deep/ .el-input__inner {
      padding-left: 40px;
      height: 36px;
      border: 1px solid #e1e1e1;
      border-radius: 36px;
    }

    /deep/ .el-input__prefix .el-input__icon {
      width: 35px;
      line-height: 36px;
      font-size: 18px;
    }
  }

  .my_collapse {
    .my_collapse_item {
      &.my_collapse_item:not(.is_active) {
        .add_module_item {
          opacity: 0;
          margin: 0;
          height: 0;
        }
      }
    }
  }

  &.c-custom_modular {
    /deep/ .c-custom_my_collapse_item {
      .my_collapse_item_body {
        .my_collapse_item_body_wrap {
          grid-template-columns: repeat(3, 1fr);
          display: grid;
          .add_module_item,.add_module_layout {
            overflow: unset;
            width: auto;
            height: auto;
            padding: 6px 4px;
            .add_module_box {
              justify-content: flex-start;
              .add_module_text {
                // white-space: nowrap;
                white-space: normal;
                word-break: auto-phrase;
              }
            }
          }
        }
      }
    }
  }
}

.add_module_item,
.add_module_layout {
  overflow: hidden;
  display: inline-block;
  margin: 3px 5px 2px;
  width: 74px;
  height: 74px;
  text-align: center;
  opacity: 1;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.13);
    background: #fff;
    border-radius: 6px;
    color: #5874d8;
  }

  .add_module_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .add_module_icon {
      width: 46px;
      height: 36px;
      margin-bottom: 5px;
      background-image: url(~@/assets/image/cssSprite.png);
      background-repeat: no-repeat;
    }

    .add_module_icon_new {
      width: 46px;
      height: 36px;
      margin-bottom: 5px;
    }

    .basic_crumbs {
      font-size: 28px;
      line-height: 36px;
      color: #14141559;
      font-weight: bold;
    }

    .add_module_text {
      font-size: 12px;
      line-height: 1;
      color: #4c4c4c;
    }

    &:hover {
      .add_module_icon {
        background-position-y: -695px !important;
      }
      
      .basic_list_photos {
        background-position-y: -698px !important;
      }

      .basic_video {
        background-position-y: -694px !important;
      }

      .basic_notice {
        background-position-y: -696px !important;
      }

      .basic_banner {
        background-position-y: -696px !important;
      }

      .add_module_text {
        color: #0078d7 !important;
      }

      .basic_crumbs {
        color: #0078d7 !important;
        font-weight: bold;
      }
    }

    &:hover {
      .module-icon-private {
        background-position: -46px 0 !important;
      }
    }
  }
}

.tip-not-support {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/module/add_module.vue